import { gql } from '@apollo/client';

export * from './blockingAppCandidates.query.generated';

export const BLOCKING_APP_CANDIDATES = gql`
  query blockingAppCandidates($page: Int, $perPage: Int) {
    apps(owned: true, productsExist: true, page: $page, perPage: $perPage) {
      pagesCount
      nodes {
        id
        name
        logoUrl
        unclaimed
      }
    }
  }
`;
